import gql from 'graphql-tag';

export const startPlaceMaintenanceMode = gql`
  mutation startPlaceMaintenanceMode($placeId: Int!, $workOrderId: Int!) {
    startPlaceMaintenanceMode(placeId: $placeId, workOrderId: $workOrderId) {
      maintenanceModeId
      devices
      propagatedPlaceIds
    }
  }
`;

export const cancelPlaceMaintenanceMode = gql`
  mutation cancelPlaceMaintenanceMode($maintenanceModeId: Int!) {
    cancelPlaceMaintenanceMode(maintenanceModeId: $maintenanceModeId)
  }
`;
